module.exports = __webpack_public_path__ + "img/13.e0cf9cc1.png";